<div class="modal-header co-header p-3">
  <div class="d-flex align-items-center gap-3 min-w-0">
    <div class="co-avatar flex-shrink-0">{{ initials || "?" }}</div>
    <div class="min-w-0 text-white">
      <div class="d-flex align-items-center gap-2 flex-wrap">
        <h5 class="mb-0 text-white fw-semibold text-truncate">{{ overview ? displayName : ("t-contact-overview.t-title" | translate) }}</h5>
        <span *ngFor="let type of overview?.contact?.types" class="badge co-type-badge fs-11">
          {{ "t-lead-" + type.toLowerCase() | translate }}
        </span>
      </div>
      <div *ngIf="overview" class="d-flex align-items-center gap-3 flex-wrap fs-12 mt-1 co-header-meta">
        <span *ngIf="overview.contact.email" class="text-truncate"><i class="ri-mail-line me-1"></i>{{ overview.contact.email }}</span>
        <span *ngIf="overview.contact.phoneNumber"><i class="ri-phone-line me-1"></i>{{ overview.contact.phoneNumber | formatNumber }}</span>
        <span *ngIf="overview.contact.ownerUser"><i class="ri-user-star-line me-1"></i>{{ overview.contact.ownerUser.name }}</span>
        <span><i class="ri-calendar-line me-1"></i>{{ overview.contact.createdAt | date: "dd/MM/yyyy" }}</span>
      </div>
    </div>
  </div>

  <button type="button" class="btn-close btn-close-white btn-close-white-agent" aria-label="Close"
    (click)="closeModal()"></button>
</div>

<div class="modal-body p-0">
  <div *ngIf="loading" class="co-body co-state d-flex align-items-center justify-content-center text-muted">
    {{ "t-reload-history" | translate }}
  </div>

  <div *ngIf="!loading && error" class="co-body co-state d-flex align-items-center justify-content-center text-muted">
    {{ "t-no-result-message" | translate }}
  </div>

  <ng-container *ngIf="!loading && overview">
    <ul ngbNav #nav="ngbNav" [activeId]="activeTab" (activeIdChange)="onTabChange($event)"
      class="nav nav-tabs nav-tabs-custom px-3 pt-2">

      <li [ngbNavItem]="'summary'">
        <a ngbNavLink>
          <i class="ri-dashboard-line align-bottom me-1"></i>
          {{ "t-contact-overview.t-tab-summary" | translate }}
        </a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="summaryTab"></ng-container>
        </ng-template>
      </li>

      <li [ngbNavItem]="'leads'">
        <a ngbNavLink>
          <i class="ri-user-received-2-line align-bottom me-1"></i>
          {{ "t-contact-overview.t-tab-leads" | translate }}
          <span class="badge rounded-pill ms-1" [ngClass]="activeTab === 'leads' ? 'badge-soft-primary' : 'bg-light text-muted'">
            {{ overview.summary.leadsTotal }}
          </span>
        </a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="leadsTab"></ng-container>
        </ng-template>
      </li>

      <li [ngbNavItem]="'deals'">
        <a ngbNavLink>
          <i class="ri-briefcase-4-line align-bottom me-1"></i>
          {{ "t-contact-overview.t-tab-deals" | translate }}
          <span class="badge rounded-pill ms-1" [ngClass]="activeTab === 'deals' ? 'badge-soft-primary' : 'bg-light text-muted'">
            {{ overview.deals.length }}
          </span>
        </a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="dealsTab"></ng-container>
        </ng-template>
      </li>

      <li [ngbNavItem]="'visits'">
        <a ngbNavLink>
          <i class="ri-calendar-check-line align-bottom me-1"></i>
          {{ "t-contact-overview.t-tab-visits" | translate }}
          <span class="badge rounded-pill ms-1" [ngClass]="activeTab === 'visits' ? 'badge-soft-primary' : 'bg-light text-muted'">
            {{ overview.summary.visitsTotal }}
          </span>
        </a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="visitsTab"></ng-container>
        </ng-template>
      </li>

      <li [ngbNavItem]="'properties'">
        <a ngbNavLink>
          <i class="ri-home-4-line align-bottom me-1"></i>
          {{ "t-contact-overview.t-tab-properties" | translate }}
          <span class="badge rounded-pill ms-1" [ngClass]="activeTab === 'properties' ? 'badge-soft-primary' : 'bg-light text-muted'">
            {{ overview.properties.length }}
          </span>
        </a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="propertiesTab"></ng-container>
        </ng-template>
      </li>

      <li [ngbNavItem]="'activity'">
        <a ngbNavLink>
          <i class="ri-time-line align-bottom me-1"></i>
          {{ "t-contact-overview.t-tab-activity" | translate }}
        </a>
        <ng-template ngbNavContent>
          <app-contact-overview-activity [items]="activity" [loading]="loadingActivity">
          </app-contact-overview-activity>
        </ng-template>
      </li>
    </ul>

    <ngx-simplebar class="co-body">
      <div class="p-3" [ngbNavOutlet]="nav"></div>
    </ngx-simplebar>
  </ng-container>
</div>

<!-- ===================== RESUMO ===================== -->
<ng-template #summaryTab>
  <div class="row g-3 mb-4">
    <div class="col-6 col-lg-3">
      <div class="co-tile co-tile-primary">
        <div class="co-tile-icon"><i class="ri-user-received-2-line"></i></div>
        <div>
          <p class="co-tile-value">{{ overview!.summary.leadsTotal }}</p>
          <p class="co-tile-label">{{ "t-contact-overview.t-leads-total" | translate }}</p>
          <p class="co-tile-sub">
            {{ overview!.summary.leadsBuyer }} {{ "t-proposals.t-buyer" | translate | lowercase }} ·
            {{ overview!.summary.leadsOwner }} {{ "t-lead-owner" | translate | lowercase }}
          </p>
        </div>
      </div>
    </div>
    <div class="col-6 col-lg-3">
      <div class="co-tile co-tile-warning">
        <div class="co-tile-icon"><i class="ri-briefcase-4-line"></i></div>
        <div>
          <p class="co-tile-value">{{ overview!.summary.dealsOpen + overview!.summary.processesOpen }}</p>
          <p class="co-tile-label">{{ "t-contact-overview.t-deals-open" | translate }}</p>
          <p class="co-tile-sub">
            <span class="text-success">{{ overview!.summary.dealsWon }} {{ "t-contact-overview.t-deals-won" | translate }}</span> ·
            <span class="text-danger">{{ overview!.summary.dealsLost }} {{ "t-contact-overview.t-deals-lost" | translate }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="col-6 col-lg-3">
      <div class="co-tile co-tile-success">
        <div class="co-tile-icon"><i class="ri-home-smile-line"></i></div>
        <div>
          <p class="co-tile-value">{{ overview!.summary.propertiesBought }} <span class="co-tile-sep">/</span> {{ overview!.summary.propertiesSold }}</p>
          <p class="co-tile-label">{{ "t-contact-overview.t-bought" | translate }} / {{ "t-contact-overview.t-sold" | translate }}</p>
          <p class="co-tile-sub">
            {{ overview!.summary.potentialBuys }} {{ "t-contact-overview.t-potential-buys" | translate | lowercase }} ·
            {{ overview!.summary.potentialSells }} {{ "t-contact-overview.t-potential-sells" | translate | lowercase }}
          </p>
        </div>
      </div>
    </div>
    <div class="col-6 col-lg-3">
      <div class="co-tile co-tile-info">
        <div class="co-tile-icon"><i class="ri-calendar-check-line"></i></div>
        <div>
          <p class="co-tile-value">{{ overview!.summary.visitsTotal }} <span class="co-tile-sep">/</span> {{ overview!.summary.proposalsTotal }}</p>
          <p class="co-tile-label">{{ "t-contact-overview.t-visits" | translate }} / {{ "t-contact-overview.t-proposals" | translate }}</p>
          <p class="co-tile-sub">
            {{ overview!.summary.visitsDone }} {{ "t-contact-overview.t-visits-done" | translate }} ·
            {{ overview!.summary.mediationAgreements }} {{ "t-contact-overview.t-mediation-short" | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="row g-3">
    <div class="col-md-6">
      <p class="co-section-title mb-2"><i class="ri-briefcase-4-line me-1"></i>{{ "t-contact-overview.t-recent-deals" | translate }}</p>
      <ng-container *ngIf="recentDeals.length > 0; else emptyRecentDeals">
        <ng-container *ngFor="let deal of recentDeals">
          <ng-container *ngTemplateOutlet="dealRow; context: { $implicit: deal }"></ng-container>
        </ng-container>
      </ng-container>
      <ng-template #emptyRecentDeals>
        <p class="co-empty fs-13 mb-0">{{ "t-contact-overview.t-empty-deals" | translate }}</p>
      </ng-template>
    </div>

    <div class="col-md-6">
      <p class="co-section-title mb-2"><i class="ri-user-received-2-line me-1"></i>{{ "t-contact-overview.t-recent-leads" | translate }}</p>
      <ng-container *ngIf="recentLeads.length > 0; else emptyRecentLeads">
        <ng-container *ngFor="let lead of recentLeads">
          <ng-container *ngTemplateOutlet="leadRow; context: { $implicit: lead, compact: true }"></ng-container>
        </ng-container>
      </ng-container>
      <ng-template #emptyRecentLeads>
        <p class="co-empty fs-13 mb-0">{{ "t-contact-overview.t-empty-leads" | translate }}</p>
      </ng-template>
    </div>
  </div>
</ng-template>

<!-- ===================== LEADS ===================== -->
<ng-template #leadsTab>
  <ng-container *ngIf="overview!.leads.length > 0; else emptyLeads">
    <ng-container *ngFor="let lead of overview!.leads">
      <ng-container *ngTemplateOutlet="leadRow; context: { $implicit: lead, compact: false }"></ng-container>
    </ng-container>
    <p *ngIf="overview!.limits.truncated.leads" class="co-empty fs-12 mt-2 mb-0">
      {{ "t-contact-overview.t-truncated" | translate: { count: overview!.limits.take } }}
    </p>
  </ng-container>
  <ng-template #emptyLeads>
    <div class="py-4 text-center co-empty">
      <i class="ri-inbox-line fs-24 d-block mb-2"></i>
      {{ "t-contact-overview.t-empty-leads" | translate }}
    </div>
  </ng-template>
</ng-template>

<ng-template #leadRow let-lead let-compact="compact">
  <div class="co-row co-row-link" (click)="open(lead.link)">
    <div class="d-flex align-items-start gap-2">
      <div class="flex-grow-1 min-w-0">
        <div class="d-flex align-items-center gap-2 flex-wrap mb-1">
          <span class="badge fs-11" [ngClass]="lead.leadType === 'OWNER' ? 'badge-soft-success' : 'badge-soft-primary'">
            {{ lead.leadType === 'OWNER' ? ('t-lead-owner' | translate) : ('t-proposals.t-buyer' | translate) }}
          </span>
          <span *ngIf="lead.isArchived" class="badge badge-soft-secondary fs-11">
            {{ "t-contact-overview.t-archived" | translate }}
          </span>
          <span class="text-muted fs-12">{{ lead.createdAt | date: "dd/MM/yyyy" }}</span>
          <span *ngIf="lead.source" class="text-muted fs-12">
            · {{ (lead.source.translateKey || lead.source.name) | translate }}
          </span>
          <span *ngIf="lead.agent" class="text-muted fs-12">
            · <i class="ri-user-line"></i> {{ lead.agent.name }}
          </span>
        </div>

        <app-contact-overview-property-card
          [property]="lead.property"
          [externalReference]="lead.externalReference"
          [clickable]="false">
        </app-contact-overview-property-card>

        <div *ngIf="!compact" class="d-flex align-items-center gap-2 flex-wrap mt-2">
          <ng-container *ngFor="let d of [lead.deal, lead.listing, lead.process]">
            <button *ngIf="d" type="button" class="btn btn-sm btn-light fs-11 py-0 px-2 d-inline-flex align-items-center gap-1"
              (click)="$event.stopPropagation(); open(d.link)">
              <span class="co-stage-dot" [style.background-color]="d.stage?.color || null"></span>
              {{ dealTypeKey(d) | translate }}:
              {{ (d.stage?.translateKey || d.stage?.name) | translate }}
              <i *ngIf="d.isWon" class="ri-trophy-line text-success"></i>
              <i *ngIf="d.isLost" class="ri-close-circle-line text-danger"></i>
            </button>
          </ng-container>
          <span class="text-muted fs-12 ms-auto">
            {{ lead.proposalsCount }} {{ "t-contact-overview.t-proposals" | translate | lowercase }} ·
            {{ lead.visitsCount }} {{ "t-contact-overview.t-visits" | translate | lowercase }}
          </span>
        </div>
      </div>

      <button type="button" class="btn btn-sm btn-soft-primary btn-icon flex-shrink-0"
        [ngbTooltip]="(lead.isConverted ? 't-contact-overview.t-open-deal' : 't-contact-overview.t-open-lead') | translate"
        container="body" (click)="$event.stopPropagation(); open(lead.link)">
        <i class="ri-external-link-line"></i>
      </button>
    </div>
  </div>
</ng-template>

<!-- ===================== NEGÓCIOS ===================== -->
<ng-template #dealsTab>
  <ng-container *ngIf="overview!.deals.length > 0; else emptyDeals">
    <ng-container *ngFor="let deal of overview!.deals">
      <ng-container *ngTemplateOutlet="dealRow; context: { $implicit: deal }"></ng-container>
    </ng-container>
  </ng-container>
  <ng-template #emptyDeals>
    <div class="py-4 text-center co-empty">
      <i class="ri-inbox-line fs-24 d-block mb-2"></i>
      {{ "t-contact-overview.t-empty-deals" | translate }}
    </div>
  </ng-template>
</ng-template>

<ng-template #dealRow let-deal>
  <div class="co-row co-row-accent co-row-link" [ngClass]="'co-row-' + deal.type" (click)="open(deal.link)">
    <div class="d-flex align-items-start gap-2">
      <div class="flex-grow-1 min-w-0">
        <div class="d-flex align-items-center gap-2 flex-wrap mb-1">
          <span class="badge fs-11" [ngClass]="dealTypeBadge(deal)">
            {{ dealTypeKey(deal) | translate }}
            <ng-container *ngIf="deal.processType === 'LEASE'"> · {{ "t-contact-overview.t-lease" | translate }}</ng-container>
          </span>
          <span class="d-inline-flex align-items-center gap-1 fs-12">
            <span class="co-stage-dot" [style.background-color]="deal.stage?.color || null"></span>
            {{ (deal.stage?.translateKey || deal.stage?.name) | translate }}
          </span>
          <span *ngIf="deal.stageSince" class="text-muted fs-12">
            · {{ "t-contact-overview.t-since" | translate }} {{ deal.stageSince | date: "dd/MM/yyyy" }}
          </span>
          <span *ngIf="deal.isWon" class="badge badge-soft-success fs-11">
            <i class="ri-trophy-line"></i> {{ "t-contact-overview.t-won" | translate }}
          </span>
          <span *ngIf="deal.isLost" class="badge badge-soft-danger fs-11">
            <i class="ri-close-circle-line"></i> {{ "t-contact-overview.t-lost" | translate }}
          </span>
          <span *ngIf="deal.saleStatus === 'COMPLETED'" class="badge badge-soft-success fs-11">
            {{ "t-contact-overview.t-sale-completed" | translate }}
          </span>
        </div>

        <app-contact-overview-property-card
          [property]="deal.property"
          [externalReference]="deal.externalReference"
          [clickable]="false">
        </app-contact-overview-property-card>
      </div>

      <button type="button" class="btn btn-sm btn-soft-primary btn-icon flex-shrink-0"
        [ngbTooltip]="'t-contact-overview.t-open-deal' | translate" container="body" (click)="$event.stopPropagation(); open(deal.link)">
        <i class="ri-external-link-line"></i>
      </button>
    </div>
  </div>
</ng-template>

<!-- ===================== VISITAS ===================== -->
<ng-template #visitsTab>
  <ng-container *ngIf="overview!.visits.length > 0; else emptyVisits">
    <div *ngFor="let visit of overview!.visits" class="co-row" [class.co-row-link]="!!visit.link"
      (click)="open(visit.link)">
      <div class="d-flex align-items-start gap-2">
        <div class="flex-grow-1 min-w-0">
          <div class="d-flex align-items-center gap-2 flex-wrap mb-1">
            <span class="badge fs-11" [ngClass]="visitStatusBadge(visit)">
              <i class="ri-calendar-event-line"></i> {{ visitStatusKey(visit) | translate }}
            </span>
            <span class="fs-12 fw-semibold">{{ visit.startAt | date: "dd/MM/yyyy HH:mm" }}</span>
            <span *ngIf="visit.agent" class="text-muted fs-12">
              · <i class="ri-user-line"></i> {{ visit.agent.name }}
            </span>
            <span *ngIf="visit.cancelReason" class="text-muted fs-12 text-truncate">
              · {{ visit.cancelReason }}
            </span>
          </div>

          <app-contact-overview-property-card
            [property]="visit.property"
            [externalReference]="visit.externalReference"
            [clickable]="false">
          </app-contact-overview-property-card>

          <!-- Resultado da visita: avaliação, notas e ficha -->
          <div *ngIf="visit.agentRating || visit.notes || visit.hasSheet"
            class="d-flex align-items-center gap-3 flex-wrap mt-2 fs-12">
            <span *ngIf="visit.agentRating" class="d-inline-flex align-items-center gap-1"
              [ngbTooltip]="'t-deals-detail-agent-rating' | translate" container="body">
              <span class="text-warning">
                <i *ngFor="let position of starPositions" class="{{ starIcon(visit, position) }}"></i>
              </span>
              <span class="text-muted">{{ visit.agentRating }}/5</span>
            </span>
            <span *ngIf="visit.hasSheet" class="badge badge-soft-info fs-11">
              <i class="ri-file-list-3-line"></i> {{ "t-contact-overview.t-visit-sheet" | translate }}
            </span>
            <span *ngIf="visit.notes" class="text-muted co-visit-notes" [ngbTooltip]="visit.notes" container="body">
              <i class="ri-sticky-note-line me-1"></i>{{ visit.notes }}
            </span>
          </div>
        </div>

        <div class="d-flex gap-1 flex-shrink-0">
          <button *ngIf="visit.link" type="button" class="btn btn-sm btn-soft-secondary btn-icon"
            [ngbTooltip]="(visit.link.type === 'lead' ? 't-contact-overview.t-open-lead' : 't-contact-overview.t-open-deal') | translate"
            container="body" (click)="$event.stopPropagation(); open(visit.link)">
            <i class="ri-briefcase-4-line"></i>
          </button>
          <button *ngIf="visit.property" type="button" class="btn btn-sm btn-soft-primary btn-icon"
            [ngbTooltip]="'t-contact-overview.t-open-property' | translate" container="body"
            (click)="$event.stopPropagation(); open(visit.property.link)">
            <i class="ri-external-link-line"></i>
          </button>
        </div>
      </div>
    </div>
    <p *ngIf="overview!.limits.truncated.visits" class="co-empty fs-12 mt-2 mb-0">
      {{ "t-contact-overview.t-truncated" | translate: { count: overview!.limits.take } }}
    </p>
  </ng-container>
  <ng-template #emptyVisits>
    <div class="py-4 text-center co-empty">
      <i class="ri-inbox-line fs-24 d-block mb-2"></i>
      {{ "t-contact-overview.t-empty-visits" | translate }}
    </div>
  </ng-template>
</ng-template>

<!-- ===================== IMÓVEIS ===================== -->
<ng-template #propertiesTab>
  <ng-container *ngIf="propertyCount('ALL') > 0; else emptyProperties">
    <ul class="nav nav-pills nav-custom-outline nav-primary rounded border-bottom-0 mb-3 flex-wrap" role="tablist">
      <li class="nav-item" *ngFor="let f of propertyFilters">
        <a class="nav-link d-inline-flex align-items-center gap-1" role="tab" href="javascript:void(0)"
          [class.active]="propertyFilter === f.value" (click)="setPropertyFilter(f.value)">
          {{ f.labelKey | translate }}
          <span class="badge rounded-pill fs-11"
            [ngClass]="propertyFilter === f.value ? 'bg-white text-primary' : 'bg-light text-muted'">
            {{ propertyCount(f.value) }}
          </span>
        </a>
      </li>
    </ul>

    <div *ngFor="let group of visiblePropertyGroups" class="mb-3">
      <p class="co-section-title mb-2 d-flex align-items-center gap-2" *ngIf="propertyFilter === 'ALL'">
        <span class="badge fs-11" [ngClass]="group.badgeClass">{{ group.items.length }}</span>
        {{ group.labelKey | translate }}
      </p>

      <div *ngFor="let row of group.items" class="co-row" [class.co-row-link]="!!row.property"
        (click)="open(row.property?.link)">
        <div class="d-flex align-items-start gap-2">
          <div class="flex-grow-1 min-w-0">
            <app-contact-overview-property-card
              [property]="row.property"
              [externalReference]="row.externalReference"
              (open)="open($event.link)">
            </app-contact-overview-property-card>

            <div class="d-flex align-items-center gap-2 flex-wrap mt-1 fs-12 text-muted">
              <span class="badge fs-11" [ngClass]="group.badgeClass">{{ originKey(row) | translate }}</span>
              <span *ngIf="row.salePrice">
                <i class="ri-money-euro-circle-line"></i>
                {{ row.salePrice | currency: "EUR" : "symbol" : "1.0-0" }}
              </span>
              <span *ngIf="row.saleDate">
                <i class="ri-calendar-check-line"></i> {{ row.saleDate | date: "dd/MM/yyyy" }}
              </span>
              <span *ngIf="!row.saleDate && row.since">
                <i class="ri-calendar-line"></i> {{ row.since | date: "dd/MM/yyyy" }}
              </span>
            </div>
          </div>

          <div class="d-flex gap-1 flex-shrink-0">
            <button *ngIf="row.dealLink" type="button" class="btn btn-sm btn-soft-secondary btn-icon"
              [ngbTooltip]="'t-contact-overview.t-open-deal' | translate" container="body"
              (click)="$event.stopPropagation(); open(row.dealLink)">
              <i class="ri-briefcase-4-line"></i>
            </button>
            <button *ngIf="row.property" type="button" class="btn btn-sm btn-soft-primary btn-icon"
              [ngbTooltip]="'t-contact-overview.t-open-property' | translate" container="body"
              (click)="$event.stopPropagation(); open(row.property.link)">
              <i class="ri-external-link-line"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <p *ngIf="overview!.limits.truncated.sales || overview!.limits.truncated.properties" class="co-empty fs-12 mb-0">
      {{ "t-contact-overview.t-truncated" | translate: { count: overview!.limits.take } }}
    </p>
  </ng-container>
  <ng-template #emptyProperties>
    <div class="py-4 text-center co-empty">
      <i class="ri-inbox-line fs-24 d-block mb-2"></i>
      {{ "t-contact-overview.t-empty-properties" | translate }}
    </div>
  </ng-template>
</ng-template>
